export default {
  state: {
    staticLocations: {
      parks: {
        disneyland: {
          address1: 'Disneyland Drive',
          address2: '1313',
          city: 'Anaheim',
          country: 'United States',
          state: 'CA',
          title: '1313 Disneyland Dr, Anaheim, CA 92802, USA',
          zip: '92802',
          lat: 33.8120918,
          lng: -117.91897419999998,
          shortName: 'Disneyland Park, Anaheim, CA',
          longName: 'Disneyland Park, Disneyland Drive, Anaheim, CA, USA'
        },
        belmont: {
          address1: 'Mission Boulevard',
          address2: '3146',
          city: 'Mission Beach, San Diego',
          country: 'United States',
          state: 'CA',
          title: '3146 Mission Blvd, San Diego, CA 92109, USA',
          zip: '92109',
          lat: 32.770668,
          lng: -117.25207969999997,
          shortName: 'Belmont Park, San Diego, CA',
          longName: 'Belmont Park, Mission Boulevard, San Diego, CA, USA'
        },
        dcap: {
          address1: 'Disneyland Drive',
          address2: '1313',
          city: 'Anaheim Resort, Anaheim',
          country: 'United States',
          state: 'CA',
          title: '1313 Disneyland Dr, Anaheim, CA 92802, USA',
          zip: '92802',
          lat: 33.806112,
          lng: -117.92085900000001,
          shortName: 'Disney California Adventure Park, Anaheim, CA',
          longName: 'Disney California Adventure Park, Disneyland Drive, Anaheim, CA, USA'
        },
        knotts: {
          address1: 'Beach Boulevard',
          address2: '8039',
          city: 'Buena Park',
          country: 'United States',
          state: 'CA',
          title: '8039 Beach Blvd, Buena Park, CA 90620, USA',
          zip: '90620',
          lat: 33.8443038,
          lng: -118.0002265,
          shortName: 'Knott\'s Berry Farm, Buena Park, CA',
          longName: 'Knott\'s Berry Farm, Beach Boulevard, Buena Park, CA, USA'
        },
        legoland: {
          address1: 'Legoland Drive',
          address2: '1',
          city: 'Carlsbad',
          country: 'United States',
          state: 'CA',
          title: '1 Legoland Dr, Carlsbad, CA 92008, USA',
          zip: '90620',
          lat: 33.1261218,
          lng: -117.31148330000002,
          shortName: 'Legoland California, Carlsbad, CA',
          longName: 'LEGOLAND California, Legoland Drive, Carlsbad, CA, USA'
        },
        sfmm: {
          address1: 'Magic Mountain Parkway',
          address2: '26101',
          city: 'Valencia',
          country: 'United States',
          state: 'CA',
          title: '26101 Magic Mountain Pkwy, Valencia, CA 91355, USA',
          zip: '91355',
          lat: 34.42533049999999,
          lng: -118.59721910000002,
          shortName: 'Six Flags Magic Mountain, Valencia, CA',
          longName: 'Six Flags Magic Mountain, Magic Mountain Parkway, Valencia, CA, USA'
        },
        seaworld: {
          address1: '',
          address2: '',
          city: 'Mission Bay, San Diego',
          country: 'United States',
          state: 'CA',
          title: 'San Diego, CA 92109, USA',
          zip: '92109',
          lat: 32.76390299999999,
          lng: -117.22945700000002,
          shortName: 'SeaWorld, San Diego, CA',
          longName: 'SeaWorld, San Diego, CA, USA'
        },
        universal: {
          address1: 'Universal City Plaza',
          address2: '100',
          city: 'Studio City, Universal City',
          country: 'United States',
          state: 'CA',
          title: '100 Universal City Plaza, Studio City, CA 91604, USA',
          zip: '91604',
          lat: 34.14012969999999,
          lng: -118.360791,
          shortName: 'Universal Studios Hollywood, Universal City, CA',
          longName: 'Universal Studios Hollywood, Universal City Plaza, Studio City, CA, USA'
        }
      }
    }
  },
  mutations: {
  }
}



// WEBPACK FOOTER //
// ./src/store/reservation/static-locations.js